import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { RecentEmploymentDetailsModel } from 'src/app/model/recent-employment-details.model';

export const RequestAction = createAction('[Recent Employment Details] get data', props<{ accountId: number }>());
export const ResponseAction = createAction('[Recent Employment Details] set data', props<{ payload: RecentEmploymentDetailsModel[] }>());
